<template>
<Layout class="layout">
  <Header class="layout__header"><img src="./assets/bg.jpg" /></Header>
  <Content class="layout__content">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="top">
      <FormItem label="岗位" prop="position">
        <Select v-model="formValidate.position" placeholder="请选择您应聘的岗位">
          <Option v-for="item in positionList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="姓名" prop="name">
        <Input v-model.trim="formValidate.name" placeholder="请填写您的姓名" />
      </FormItem>
      <FormItem label="联系电话" prop="cellphone">
        <Input v-model.trim="formValidate.cellphone" placeholder="请填写您的手机号" />
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model.trim="formValidate.email" placeholder="请填写您的邮箱" />
      </FormItem>
      <FormItem label="学历" prop="education">
        <RadioGroup v-model="formValidate.education">
          <Radio :label="3">全日制大专</Radio>
          <Radio :label="1">全日制本科</Radio>
          <Radio :label="2">硕士及以上学历</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="学校" prop="school">
        <Input v-model.trim="formValidate.school" placeholder="请填写您的学校" />
      </FormItem>
      <FormItem label="专业" prop="major">
        <Input v-model.trim="formValidate.major" placeholder="请填写您的专业" />
      </FormItem>
      <FormItem label="毕业时间">
        <div class="graduation-container">
          <Select v-model="formValidate.graduationYear" placeholder="请选择您毕业的年份">
            <Option v-for="item in graduationYears" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <Select v-model="formValidate.graduationMonth" placeholder="请选择您毕业的月份">
            <Option v-for="item in graduationMonths" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
      </FormItem>
      <FormItem label="简历" prop="file">
        <Upload
          :before-upload="handleUpload"
          :show-upload-list="false"
          accept=".pdf,.doc,.docx,.wps"
          :max-size="5120"
          action="//jsonplaceholder.typicode.com/posts/">
          <Button icon="ios-cloud-upload-outline">请上传简历</Button>
          <div slot="tip" class="upload__tip">
            <p>注：可上传文件格式有pdf、doc、docx、wps。</p>
            <p>简历不超过5M</p>
          </div>
        </Upload>
        <div v-if="formValidate.file">
          {{ formValidate.file.name }}
        </div>
      </FormItem>
      <FormItem label="作品" prop="works">
        <Input v-model.trim="other" placeholder="请填写您的作品链接" />
        <Upload
          :before-upload="handleUploadWorks"
          :show-upload-list="false"
          accept=".jpg,.png,.pdf,.zip,.rar"
          :max-size="5120"
          action="//jsonplaceholder.typicode.com/posts/">
          <Button icon="ios-cloud-upload-outline">请上传作品</Button>
          <div slot="tip" class="upload__tip">
            <p>注：可上传文件格式有jpg、png、pdf、zip、rar。</p>
            <p>作品不超过5M</p>
          </div>
        </Upload>
        <div v-if="formValidate.works">
          {{ formValidate.works.name }}
        </div>
      </FormItem>
      <FormItem label="从哪儿获知招聘信息" prop="way">
        <RadioGroup v-model="formValidate.way">
          <Radio :label="1">老师推荐</Radio>
          <Radio :label="2">淘米招聘公众号</Radio>
          <Radio :label="3">其他</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="otherWay" v-if="formValidate.way === 3">
        <Input v-model.trim="formValidate.otherWay" placeholder="请填写您获取招聘信息的渠道" />
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')">提交</Button>
      </FormItem>
    </Form>
  </Content>
</Layout>
</template>
<script>

export default {
  data () {
    return {
      positionList: [
        {
          value: 'cehua',
          label: '系统策划'
        },
        {
          value: 'game',
          label: '游戏运营'
        },
        {
          value: 'content',
          label: '内容运营'
        },
        {
          value: 'kaifa',
          label: '游戏客户端开发工程师（AS方向）'
        },
        {
          value: 'meishu',
          label: '游戏美术（角色原画、场景原画、UI设计、游戏动效）'
        },
        {
          value: 'shixi',
          label: '【2025届校招】游戏服务器端开发工程师（实习）'
        }
      ],
      graduationYears: [
        {
          value: '2023',
          label: '2023年'
        },
        {
          value: '2024',
          label: '2024年'
        },
        {
          value: '2025',
          label: '2025年'
        }
      ],
      graduationMonths: [
        {
          value: '1',
          label: '1月'
        },
        {
          value: '2',
          label: '2月'
        },
        {
          value: '3',
          label: '3月'
        },
        {
          value: '4',
          label: '4月'
        },
        {
          value: '5',
          label: '5月'
        },
        {
          value: '6',
          label: '6月'
        },
        {
          value: '7',
          label: '7月'
        },
        {
          value: '8',
          label: '8月'
        },
        {
          value: '9',
          label: '9月'
        },
        {
          value: '10',
          label: '10月'
        },
        {
          value: '11',
          label: '11月'
        },
        {
          value: '12',
          label: '12月'
        }
      ],
      formValidate: {
        position: 'kaifa',
        name: '',
        cellphone: '',
        email: '',
        education: '',
        school: '',
        major: '',
        graduationYear: '2024',
        graduationMonth: '7',
        file: null,
        other: '',
        works: null,
        way: ''
      },
      ruleValidate: {
        position: [
          { required: true, message: '请选择您应聘的岗位', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请填写您的姓名', trigger: 'blur' }
        ],
        cellphone: [
          { required: true, message: '请填写您的联系电话', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value) {
                if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
                  callback('手机号格式错误')
                } else {
                  callback()
                }
              } else {
                callback()
              }
          }, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请填写您的邮箱', trigger: 'blur' }
        ],
        education: [
          { required: true, message: '请选择您的学历' }
        ],
        school: [
          { required: true, message: '请填写您的学校', trigger: 'blur' }
        ],
        major: [
          { required: true, message: '请填写您的专业', trigger: 'blur' }
        ],
        file: [
          { required: true, validator: (rule, value, callback) => {
              if (value) {
                if (value.size > 5 * 1024 * 1024) {
                  callback('简历大小不能超过5M')
                } else {
                  callback()
                }
              } else {
                callback(new Error('请上传您的简历'))
              }
          } }
        ],
        works: [
          { required: false, validator: (rule, value, callback) => {
              if (value) {
                if (value.size > 5 * 1024 * 1024) {
                  callback('作品大小不能超过5M')
                } else {
                  callback()
                }
              } else {
                callback()
              }
          } }
        ],
        way: [
          { required: true, message: '请选择您获知招聘信息的方式' }
        ],
        otherWay: [
          { validator: (rule, value, callback) => {
              if (this.formValidate.way === 3) {
                if (value) {
                  console.log(value);
                  callback()
                } else {
                  callback('请填写您获知招聘信息的方式')
                }
              } else {
                callback()
              }
          } }
        ]
      }
    }
  },
  methods: {
    handleUpload (file) {
      this.formValidate.file = file
      this.$refs.formValidate.validateField('file')
      return false;
    },
    handleUploadWorks (file) {
      this.formValidate.works = file
      this.$refs.formValidate.validateField('works')
      return false;
    },
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$Spin.show()
          let formData = new FormData()
          for (let i in this.formValidate) {
            formData.append(i, this.formValidate[i])
          }
          formData.append('graduation', this.formValidate.graduationYear + '-' + this.formValidate.graduationMonth)
          this.$http.post('//webevent.61.com/v2/?r=job/save', formData)
            .then(({ status, data })=> {
              this.$Spin.hide()
              if (status === 200) {
                if (data.result === 0) {
                  this.formValidate.file = null
                  this.formValidate.works = null
                  this.$refs.formValidate.resetFields()
                  this.$Message.success('恭喜您提交成功啦!')
                } else {
                  if (data.msg.key) {
                    this.$Message.error(data.msg.value)
                  } else {
                    this.$Message.error(data.msg)
                  }
                }
              } else {
                this.$Message.error('抱歉，网络开了点小差，请过会儿重试!')
              }
            })
            .catch(() => {
              this.$Spin.hide()
              this.$Message.error('抱歉，网络开了点小差，请过会儿重试!')
            })
        }
      })
    }
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.layout {
  max-width: 640px;
  margin: 0 auto;
}
.layout__header {
  height: auto;
  line-height: initial;
  padding: 0;
  background: none;
  font-size: 0;
}
.layout__header img {
  width: 100%;
}
.layout__content {
  padding: 2rem 1rem;
  background: #fff;
}
.upload__tip {
  color: #b2b2b2;
  font-size: 12px;
  line-height: 15px;
  padding-top: 10px;
}
.narrow-item >>> .ivu-form-item-label {
  padding-bottom: 0;
}
.narrow-item >>> .ivu-form-item-content {
  margin-top: -9px;
}

.graduation-container {
  display: flex;
}
.graduation-container >>> .ivu-select {
  margin-right: 5px;
}
</style>
